var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"catalog-container"},_vm._l((_vm.items),function(itemData){return _c('investment-catalog-item',_vm._b({key:itemData.title},'investment-catalog-item',itemData,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }